import { render, staticRenderFns } from "./ReleasesView.vue?vue&type=template&id=628d43ab"
import script from "./ReleasesView.vue?vue&type=script&lang=js"
export * from "./ReleasesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports